"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonWrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_loading_skeleton_1 = tslib_1.__importDefault(require("react-loading-skeleton"));
require("react-loading-skeleton/dist/skeleton.css");
var SkeletonWrapper_styles_1 = require("./SkeletonWrapper.styles");
var SkeletonWrapper = function (props) {
    var skeletonContainerBoxProps = props.skeletonContainerBoxProps, skeletonProps = tslib_1.__rest(props, ["skeletonContainerBoxProps"]);
    var _a = skeletonContainerBoxProps !== null && skeletonContainerBoxProps !== void 0 ? skeletonContainerBoxProps : {}, lineHeight = _a.lineHeight, boxProps = tslib_1.__rest(_a, ["lineHeight"]);
    return (
    //fix for the breaking change(https://github.com/dvtng/react-loading-skeleton#the-height-of-my-container-is-off-by-a-few-pixels)
    react_1.default.createElement(SkeletonWrapper_styles_1.StyledSkeletonWrapper, tslib_1.__assign({}, boxProps, { lineHeight: lineHeight, "data-testid": "skeleton-wrapper" }),
        react_1.default.createElement(react_loading_skeleton_1.default, tslib_1.__assign({}, skeletonProps))));
};
exports.SkeletonWrapper = SkeletonWrapper;
//# sourceMappingURL=SkeletonWrapper.js.map